// Vendor documents types
export const VENDOR_DOCUMENT_TYPES = {
  NDA: 'NDA',
  OTHER: 'OTHER',
};
export const UPLOADED_VENDOR_DOCUMENT_TYPES_VALUES = {
  CONTRACT: 'Contract',
  ANNEX: 'Annex',
  NDA: 'NDA',
  OTHER: 'Other',
};
export const ALL_VENDOR_DOCUMENT_TYPES_VALUES = {
  CONTRACT: 'Contract',
  NDA: 'NDA',
  OTHER: 'Other',
};
//
